module.exports = __webpack_public_path__ + "img/banner.7d40dd4e.png";